import { render, staticRenderFns } from "./cobrancaRecorrente.vue?vue&type=template&id=6bd170c7&"
import script from "./cobrancaRecorrente.vue?vue&type=script&lang=js&"
export * from "./cobrancaRecorrente.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports